import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import Modal from 'react-modal'
import dragscroll from 'dragscroll'
import classNames from 'classnames'
import {createStructuredSelector} from 'reselect'

import * as pdpActions from '../../../actions/productDetailPage'
import * as pane from '../../../store/pane'
import * as pdp from '../../../store/productDetailPage'

import ProductZoomImage from './ProductZoomImage'
import ProductThumbnails from '../../Pieces/ProductThumbnails'
import ProductZoomControls from './ProductZoomControls'
import ModalCloseButton from '../../ModalCloseButton'

import '../../../../scss/components/_product-zoom-modal.scss'

class ProductZoomModal extends Component {
  setInitialScroll() {
    const modal = document.getElementsByClassName('zoom-modal-container')[0]
    modal.scrollTop = this.props.isKitOrGroup || this.props.categorySlug === 'vests' ? 0 : 500
    modal.scrollLeft = 180
    // Photo is centered vertically and horizontally
    dragscroll.reset()
  }

  render() {
    const {
      closeZoomModal,
      displayedProduct,
      isDesktop,
      productImages,
      selectZoomThumbnail,
      zoomModalIsOpen,
    } = this.props
    const modalClasses = classNames('zoom-modal-container', {dragscroll: isDesktop})
    const overlayClasses = classNames('zoom-overlay', {dragscroll: isDesktop})
    return (
      <Modal
        className={modalClasses}
        overlayClassName={overlayClasses}
        isOpen={zoomModalIsOpen}
        contentLabel="Modal"
        onRequestClose={closeZoomModal}
      >
        <ModalCloseButton onClick={closeZoomModal} />
        <ProductThumbnails
          displayedProduct={displayedProduct}
          modifier="zoom"
          onClick={selectZoomThumbnail}
          productImages={productImages}
        />
        <ProductZoomImage
          onLoad={() => {
            this.setInitialScroll()
          }}
        />
        <ProductZoomControls />
      </Modal>
    )
  }
}

ProductZoomModal.propTypes = {
  closeZoomModal: PropTypes.func.isRequired,
  displayedProduct: PropTypes.shape({}),
  isDesktop: PropTypes.bool.isRequired,
  categorySlug: PropTypes.string,
  isKitOrGroup: PropTypes.bool.isRequired,
  productImages: PropTypes.arrayOf(PropTypes.shape({})),
  selectZoomThumbnail: PropTypes.func.isRequired,
  zoomModalIsOpen: PropTypes.bool,
}

const mapStateToProps = createStructuredSelector({
  categorySlug: pdp.productCategorySlug,
  displayedProduct: pdp.product,
  isDesktop: pane.windowIsDesktop,
  isKitOrGroup: pdp.productIsKitOrGroup,
  productImages: pdp.productAndModelImages,
  zoomModalIsOpen: pdp.zoomModalIsOpen,
})

const mapDispatchToProps = {
  closeZoomModal: pdpActions.closeZoomModal,
  selectZoomThumbnail: pdpActions.selectZoomThumbnail,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductZoomModal)
